import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { endpoints } from '../endpoints';
import { IFullTeamAssessment } from '../models/fullTeamAssessment';
import { ErrorService } from '../helpers/errorService';

@Injectable({
  providedIn: 'root'
})
export class FullTeamAssessmentService {
    constructor(
        private http: HttpClient,
        private errorService: ErrorService
    ) { }

    getFullTeamAssessmentByCaseId(caseId: string): Observable<IFullTeamAssessment> {
        const url = environment.apiBaseUrl + endpoints.getFullTeamAssessmentByCaseId.replace(':caseId', caseId);
        return this.http.get<IFullTeamAssessment>(url).pipe(
            catchError(this.errorService.handleError)
        );
    }

    updateFullTeamAssessment(data: IFullTeamAssessment): Observable<any> {
        const url = environment.apiBaseUrl + endpoints.updateFullTeamAssessment;
        return this.http.post(url, data).pipe(
            catchError(this.errorService.handleSavingError)
        );
    }
}